module.exports = __webpack_public_path__ + "static/media/arrow.3d7652c6.svg";